export default function (Component) {
Component.options.__docs = "<p>The prop <code>selectedId</code> supports the <code>.sync</code>-modifier. This way you can bind the selection of the navigation to your data model.</p>\n"
}